import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import { Field } from 'redux-form';

import FullWidthInlineNotification from '../../../ErrorNotification/FullWidthInlineNotification';
import Checkbox from '../../../fields/Checkbox';
import * as V from '../../../../lib/validations';

const WrongPersonConfirmation = () => (
  <>
    <FullWidthInlineNotification
      kind='warning'
      title={i18n.getStr(
        'components.Report.Dispute.wrongPersonConfirmation.title',
      )}
      subtitle={i18n.getStr(
        'components.Report.Dispute.wrongPersonConfirmation.message',
      )}
      hideCloseButton
    />
    <div>
      <Field
        type='checkbox'
        name='accepted'
        label='components.Report.Dispute.wrongPersonConfirmation.label'
        component={Checkbox}
        validate={[V.requiredCheckbox]}
        className='mb-0'
        boldLabel
        i18n
      />
    </div>
  </>
);

export default WrongPersonConfirmation;
